import { useQuery } from "@tanstack/react-query";
import { qrBatchApi } from "./axios";
import {
  DataI,
  ServiceResponseI,
  QrBatchI,
  QrBatchCreatedI,
  CreateQrBatchRequiredI,
  PropsQrBatchI,
} from "../../interfaces";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { AxiosError } from "axios";

const getAllQrBatch = async ({
  pagination,
  sorting,
  storeId,
}: PropsQrBatchI): Promise<ServiceResponseI<DataI<QrBatchI>>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const params = new URLSearchParams();
    params.append("page", (pagination!.pageIndex + 1).toString());
    params.append("limit", pagination!.pageSize.toString());
    storeId && params.append("storeId", storeId.toString());
    sorting && params.append("sorting", JSON.stringify(sorting ?? []));

    const { data } = await qrBatchApi.get<ServiceResponseI<DataI<QrBatchI>>>(
      "",
      { params, headers: { Authorization: validateToken } },
    );
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((err as Error).message);
  }
};

export const qrBatchGenerate = async (
  payload: CreateQrBatchRequiredI,
): Promise<ServiceResponseI<QrBatchCreatedI>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const { data } = await qrBatchApi.post<ServiceResponseI<QrBatchCreatedI>>(
      "/generate",
      payload,
      { headers: { Authorization: validateToken } },
    );
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const useQrBatches = ({ pagination, sorting, storeId }: PropsQrBatchI) => {
  const qrBatchesQuery = useQuery(
    ["qr-batches", { pagination, sorting, storeId }],
    () => getAllQrBatch({ pagination, sorting, storeId }),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  );

  return { qrBatchesQuery };
};